// extracted by mini-css-extract-plugin
module.exports = {"ql-editor":"custom-input_ql-editor_2ACsU","placeholder":"custom-input_placeholder_DTYiu"};